import React from 'react';

const TableForGoals = ({ subCategories, handleAddingActionItemToGoal, handleAddGoalModal }) => {
    return (
        <div className="w-100 mt-2">
            <table className="w-100">
                <thead className="goal-header">
                    <tr>
                        {headers.map((head) => (
                            <th className={`${head.width} p-3  text-muted text-center`}>{head.title}</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="goal-body">
                    {!!subCategories?.goals?.length &&
                        subCategories?.goals?.map((goal, goalIndex) => (
                            <React.Fragment key={goalIndex}>
                                {goal?.gaps?.length ? (
                                    goal?.gaps?.map((item, index) => (
                                        <tr key={index} className="">
                                            {index === 0 && (
                                                <td className="p-3 text-center border border-2 fw-medium" rowSpan={goal.gaps.length}>
                                                    {goal.goal}
                                                </td>
                                            )}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td className="p-3 text-center border border-2 fw-medium">{goal.goal}</td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                </tbody>
            </table>
            {!subCategories?.goals?.length && (
                <div className="w-100 d-flex align-items-center justify-content-center flex-column mt-8">
                    <p className="text-gary600  mb-3">No goals has been created</p>
                </div>
            )}
        </div>
    );
};

export default TableForGoals;

const headers = [
    {
        title: 'Goal Name',
        width: 'w-20'
    }
];
